import { Loader } from '@progress/kendo-react-indicators'
import React, { useState } from 'react'
import { RevUserContext } from '../../context/UserContext'
import { FavoriteApi } from '../../redux/api/FavoriteApi'
import { IFavorite } from '../../types/Favorites/IFavorite'
import { IUserProfile } from '../../types/User/IUserProfile'

export const Fav = (props: FavProps) => {
    const profile = React.useContext<IUserProfile>(RevUserContext)
    const [postFavorite, { isLoading: saving }] = FavoriteApi.useSaveFavoriteMutation()
    const [deleteFavorite,] = FavoriteApi.useDeleteFavoriteMutation()
    const [favId] = useState(props.favId)
    const icon = favId ? './images/Fav_Color.png' : './images/Fav_Grey.png'

    const saveFavorite = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.stopPropagation();
        event.preventDefault();
        if (favId) {
            await deleteFavorite({ favId: favId, uid: profile.Uid });
        } else {
            let newFav = {} as IFavorite
            newFav.Name = props.name
            newFav.Category_Id = 7
            newFav.Key_Value_1 = props.contactId.toString()
            await postFavorite({ fav: newFav, uid: profile.Uid });
        }
    }
    if (saving)
        return <Loader />
    if (!profile?.Features.Revelations)
        return <></>


    return (
        <button className='icon contact-fav' onClick={saveFavorite} title='Toggle favorite' > <img alt='Favorites icon' src={icon} style={{ alignContent: 'center' }} /></button >
    )
}

export type FavProps = {
    favId: number,
    name: string,
    contactId: number,
    toggleFavorite?: () => void
}